class ReassignFundingLineModalController {
  constructor($uibModalInstance, $http, $rootScope, toastr, project, line, obligations, obligationOptionLabel) {
    'ngInject';

    this.$uibModalInstance = $uibModalInstance;
    this.$http = $http;
    this.$rootScope = $rootScope;
    this.toastr = toastr;
    this.project = project || {};
    this.line = line || {};
    this.obligations = obligations || [];
    this.obligationOptionLabelFn = obligationOptionLabel;
    this.saving = false;
    this.selectedObligationId = line && line.contractFundingObligationId
      ? line.contractFundingObligationId
      : null;
  }

  obligationOptionLabel(obligation) {
    if (typeof this.obligationOptionLabelFn === 'function') {
      return this.obligationOptionLabelFn(obligation);
    }
    return obligation && (obligation.clin || obligation.id);
  }

  userLabel() {
    const user = this.line && this.line.user;
    if (!user) {
      return '—';
    }
    return [user.firstName, user.lastName].filter(Boolean).join(' ') || '—';
  }

  chargeCodeLabel() {
    return (this.line && this.line.chargeCode && this.line.chargeCode.name) || '—';
  }

  canSave() {
    return !!(this.selectedObligationId
      && String(this.selectedObligationId) !== String(this.line.contractFundingObligationId)
      && !this.saving);
  }

  save() {
    if (!this.canSave() || !this.project || !this.project.id || !this.line || !this.line.id) {
      return;
    }

    this.saving = true;
    this.$http.patch(
      `${this.$rootScope.apiHost}/api/admin/projects/${this.project.id}/funding/${this.line.id}`,
      { contractFundingObligationId: this.selectedObligationId },
      { withCredentials: true }
    ).then((success) => {
      this.toastr.success('Funding line reassigned to obligation');
      this.$uibModalInstance.close(success.data);
    }, (failure) => {
      const message = (failure && failure.data && failure.data.message)
        || 'Failed to update funding line obligation';
      this.toastr.error(message, 'ERROR');
    }).finally(() => {
      this.saving = false;
    });
  }

  cancel() {
    this.$uibModalInstance.dismiss();
  }
}

export default ReassignFundingLineModalController;



// WEBPACK FOOTER //
// ./client/common/modals/reassignFundingLineModal/reassignFundingLineModal.controller.js